// extracted by mini-css-extract-plugin
module.exports = {"infoForm":"UserInfoForm-module__infoForm___urCjV","submitBtn":"UserInfoForm-module__submitBtn___3tdOI","serverError":"UserInfoForm-module__serverError___2ZrGA"};